import { Info } from '@procore/core-icons'
import { borderRadius, colors, Flex, Typography } from '@procore/core-react'
import styled, { createGlobalStyle } from 'styled-components'

export const GlobalEditorStyles = createGlobalStyle<{
  zIndex: number
}>`
  :root {
    --ck-z-default: ${({ zIndex }) => zIndex};
    --ck-z-modal: ${({ zIndex }) => zIndex + 999};
    --ck-z-dialog: ${({ zIndex }) => zIndex + 1000};
  }
  
  .ck-body-wrapper {
    --ck-z-default: ${({ zIndex }) => zIndex};
    --ck-z-modal: ${({ zIndex }) => zIndex + 999};
    --ck-z-dialog: ${({ zIndex }) => zIndex + 1000};
  }
  
  .ck-balloon-panel {
    z-index: ${({ zIndex }) => zIndex + 1000} !important;
  }

  .ck-dropdown__panel {
    z-index: ${({ zIndex }) => zIndex + 1000} !important;
  }

  .ck.ck-toolbar_grouping {
    container-type: inline-size;
  }

  .ck.ck-toolbar__grouped-dropdown > .ck-dropdown__panel {
    max-width: 100cqw !important;
    z-index: ${({ zIndex }) => zIndex + 1000} !important;
  }

  .ck.ck-toolbar__grouped-dropdown > .ck-dropdown__panel .ck-toolbar__items {
    flex-wrap: wrap !important;
  }

  .ck-content {
    padding: 16px 28px !important;
    --ck-content-font-family: Inter, 'Noto Sans JP', 'Noto Sans KR', 'Noto Sans SC', 'Noto Sans TC', sans-serif;
    --ck-content-font-size: 14px;
    --ck-content-word-break: break-word;
    --ck-content-overflow-wrap: break-word;
    --ck-content-line-height: 1.4;
    overflow-x: auto;

    p {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  }

  [data-id="modal"] .ck-sticky-panel__content_sticky {
    top: var(--modal-header-height, 84px) !important;
  }

  /* Upload progress: gray the image out and show a blue bar on a white
     track inset inside the image while uploading (.ck-appear is removed
     when done). */
  .ck.ck-editor__editable .image.ck-appear,
  .ck.ck-editor__editable .image-inline.ck-appear {
    img {
      opacity: 0.70;
      transition: filter 0.2s ease-out, opacity 0.2s ease-out;
    }

    &::before {
      content: '';
      position: absolute;
      top: 16px;
      left: 16px;
      right: 16px;
      height: 8px;
      border-radius: 4px;
      background: ${colors.white};
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      z-index: 1;
    }
  }

  .ck.ck-editor__editable .image .ck-progress-bar,
  .ck.ck-editor__editable .image-inline .ck-progress-bar {
    top: 16px !important;
    height: 8px !important;
    clip-path: inset(0 16px 0 16px round 4px);
    min-width: 40px;
    background: ${colors.blue45} !important;
    z-index: 2;
    transition: width 0.15s ease-out !important;
  }
`

export const StyledTextEditor = styled.div<{
  error?: boolean
  $ready?: boolean
}>`
  .ck.ck-editor {
    opacity: ${({ $ready }) => ($ready ? 1 : 0)};
  }

  ${({ error }) =>
    error &&
    `
      .ck-sticky-panel__content {
        border-top-color: ${colors.red50} !important;
        border-left-color: ${colors.red50} !important;
        border-right-color: ${colors.red50} !important;
      }

      .ck-editor__editable {
        border-left-color: ${colors.red50} !important;
        border-right-color: ${colors.red50} !important;
        border-bottom-color: ${colors.red50} !important;
      }
    `}
`

export const StyledImageUploadWarningToast = styled(Flex)`
  background-color: ${colors.blue40};
  border-radius: ${borderRadius.md}px;
  box-shadow: 0px 8px 32px -4px hsla(200, 10%, 15%, 0.64);
  color: ${colors.white};
  min-height: 48px;
  width: 550px;
`

export const StyledImageUploadWarningToastIcon = styled(Info)`
  color: ${colors.white};
`

export const StyledReadOnlyValue = styled(Typography)`
  overflow-wrap: anywhere;
  margin-block-start: 0 !important;
  user-select: text;

  table {
    border-width: revert-layer;
    border-style: solid;
    border-color: ${colors.gray60};
    overflow-wrap: break-word;
  }

  td,
  tr,
  th,
  tbody {
    border-width: revert-layer;
    border-style: inherit;
    border-color: inherit;
  }

  p {
    line-height: normal;
  }
`
